import '../contest_result_card/index.css';
import { View, Text, Card, GadgetLeague } from '../../../component';
import { convertToDollars, isGadgetLeague } from '../../../utilities/helper';
import useTheme from '../../../utilities/hooks/theme';
import Constants from '../../../constants';
import I18n from '../../../utilities/locale';
import React from 'react';

interface Props {
  onPressCard: any;
  contest: any;
  matchVerifiedStatus: boolean;
  matchTeamScore?: any;
}
const ContestResultCardWeb = ({
  onPressCard,
  contest,
  matchTeamScore = 0,
  matchVerifiedStatus = false
}: Props) => {
  const { FantasyTheme: theme } = useTheme();

  const {
    entryFee = 0,
    winningsPerPosition = {},
    contestTeams = [],
    winningsAmount = 0,
    title = '',
    description = ''
  } = contest;

  const { rank = 1, winning: totalWinnings = 0 } = contestTeams.length > 0 ? contestTeams[0] : {};

  const isGadgetLeague_ = isGadgetLeague(title);

  let noOfWinners = 0;
  for (let key in winningsPerPosition) {
    noOfWinners += winningsPerPosition[key];
  }

  const winningsAmountValue = `${convertToDollars(winningsAmount / 100)}`;

  const surfaceColor = {
    backgroundColor: theme.contestResultCardContainer,
    border: '1px solid white !important'
  };

  const titleTextColor = {
    color: theme.contestResultCardTitle
  };

  const valueTextColor = {
    color: theme.contestResultCardValue
  };

  const cardMiddleWrapperColor = {
    borderColor: theme.contestResultCardSeparator
  };

  const separatorColor = {
    borderBottomColor: theme.contestResultCardSeparator
  };

  const prizePool = {
    color: theme.contestResultCardPrizePool
  };
  const contestHeaderStyle = {
    background: theme.contestResultCardHeaderBg,
    boxShadow: theme.contestResultCardHeaderBoxShadow
  };
  const contestContentStyle = {
    background: theme.contestResultCardContentBg,
    boxShadow: theme.contestResultCardContentBoxShadow
  };
  const viewLeaderBoardBtnStyle = {
    backgroundColor: theme.createTeamPreviewBtnLabel
  };
  return (
    <>
      <Card style={surfaceColor} className={'contest-result-card-container '}>
        <View className={'contest-result-card-bottom-wrapper'} style={contestHeaderStyle}>
          <View className={'contest-result-card-winning-amt-container'}>
            {matchVerifiedStatus && totalWinnings > 0 && (
              <React.Fragment>
                {' '}
                <Constants.Svgs.MoneyIcon
                  width={25}
                  height={25}
                  fill={theme.contestResultCardMoneyIcon}
                />
                <Text
                  className={'contest-result-card-winning-amt-title'}
                  style={{
                    color: theme.contestResultCardMoneyIcon
                  }}>
                  {`${convertToDollars(totalWinnings / 100)}`}
                </Text>
              </React.Fragment>
            )}
          </View>
        </View>
        <View className={'contest-result-card-wrapper'} style={contestContentStyle}>
          <View className={'contest-result-card-left-wrapper'}>
            <Text className={'contest-result-card-title-text'} style={titleTextColor}>
              {I18n.t('PricePool')}
            </Text>
            {isGadgetLeague_ ? (
              <GadgetLeague
                titleClassName="contest-result-card-value-text"
                titleStyle={prizePool}
                description={description}
              />
            ) : (
              <Text
                className={'contest-result-card-value-text'}
                style={{ ...valueTextColor, ...prizePool }}>{`${winningsAmountValue}`}</Text>
            )}
          </View>
          <View className={'contest-result-card-middle-wrapper'} style={cardMiddleWrapperColor}>
            <Text className={'contest-result-card-title-text '} style={titleTextColor}>
              {I18n.t('Winners')}
            </Text>
            <Text className={'contest-result-card-value-text'} style={valueTextColor}>
              {noOfWinners}
            </Text>
          </View>
          <View className={'contest-result-card-right-wrapper'}>
            <Text className={'contest-result-card-title-text '} style={titleTextColor}>
              {I18n.t('EntryFee')}
            </Text>
            <Text
              className={'contest-result-card-value-text'}
              style={valueTextColor}>{`${convertToDollars(entryFee / 100)}`}</Text>
          </View>
        </View>
        <View className={'contest-result-card-separator'} style={separatorColor} />
        <View className={'contest-result-card-wrapper'} style={contestContentStyle}>
          <View className={'contest-result-card-left-wrapper'}>
            <Text className={'contest-result-card-title-text '} style={titleTextColor}>
              {I18n.t('JoinedWith')}
            </Text>
            <Text className={'contest-result-card-value-text'} style={valueTextColor}>{`T1`}</Text>
          </View>
          <View className={'contest-result-card-middle-wrapper'} style={cardMiddleWrapperColor}>
            <Text className={'contest-result-card-title-text '} style={titleTextColor}>
              {I18n.t('Points')}
            </Text>
            <Text className={'contest-result-card-value-text'} style={valueTextColor}>
              {matchTeamScore}
            </Text>
          </View>
          <View className={'contest-result-card-right-wrapper'}>
            <Text className={'contest-result-card-title-text '} style={titleTextColor}>
              {I18n.t('Rank')}
            </Text>
            <Text
              className={'contest-result-card-value-text'}
              style={valueTextColor}>{`#${rank}`}</Text>
          </View>
        </View>
        <View className={'contest-result-card-separator'} style={separatorColor} />
      </Card>
      <View className={'contest-result-card-footer-container '}>
        <View className={'contest-result-card-footer-leaderboard-btn'}>
          <button
            className="contest-result-view-leaderboard-btn"
            style={viewLeaderBoardBtnStyle}
            onClick={onPressCard}>
            {'View Leaderboard'}
          </button>
        </View>
      </View>
    </>
  );
};
export default React.memo(ContestResultCardWeb);
